<div [formGroup]="f">
    <div class="expandCollapseContainer mb-1"  [ngClass]="!enableFilter ? 'inputDisabled' : 'inputEnabled'">
        <button class="expandCollapseHeader filterButton mb-1" (click)="onDisplayAuthorFilter()" tabindex="0">
            <strong>{{ 'author' | translate | async }}</strong>
            <ng-container *ngIf="displayAuthorFilter; else expandIcon">
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-collapse"></use>
            </svg>
            </ng-container>
            <ng-template #expandIcon>
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-expand"></use>
            </svg>
            </ng-template>
        </button>

        <div *ngIf="enableFilter && displayAuthorFilter">
            <div class="filterList pb-1">
                {{ this.author.value && (this.author.value)[0] ? (this.author.value)[0] : ''}}

                <span *ngIf="this.author.value.length > 1">
                    (+{{ this.author.value.length - 1 }}
                    {{ this.author.value.length === 2 ? 'other' : 'others' }})
                </span>
            </div>

            <mat-form-field appearance="outline" class="flex-child" color="accent">
                <mat-label>
                    {{ 'author' | translate | async }}
                </mat-label>
                <input matInput type="text" formControlName="tempAuthor" [matAutocomplete]="auto">

                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" showPanel="true"
                    (optionsScroll)="onScroll()">
                    <div *ngIf="tempAuthor.value == '' || tempAuthor.value == undefined" class="filter-item">
                        <!-- Added for accessibility - mat-option is required but if selected breaks the virtual drop-down -->
                        <mat-option (onSelectionChange)="toggleSelectAll($event)">
                            <mat-checkbox role="checkbox" class="customCheckbox" [checked]="updateAllSelected()" (change)="toggleSelectAll($event)"
                            (click)="$event.stopPropagation()">
                            {{ 'select.all' | translate | async }}
                        </mat-checkbox>
                        </mat-option>
                        
                    </div>
                    <div *ngFor="let item of filteredAuthors$ | async" class="filter-item">
                        <!-- Added for accessibility - mat-option is required but if selected breaks the virtual drop-down -->
                        <mat-option (onSelectionChange)="toggleSelection(item, $event)">
                            <mat-checkbox role="checkbox" class="customCheckbox" [checked]="isAuthorChecked(item)"
                                (change)="toggleSelection(item, $event)" (click)="$event.stopPropagation()">
                                {{ item._source.name }}
                            </mat-checkbox>
                        </mat-option>
                    </div>
                </mat-autocomplete>
            </mat-form-field>
            
        </div>
    </div>
</div>